const parseUrlSearchParams = (event) => {
  const searchParams = new URLSearchParams(event.data.payload.search);
  const hashParams = new URLSearchParams(event.data.payload.hash.substring(1));
  const searchParamsObject = getObjectOfEntries(searchParams.entries());
  const hashParamsObject = getObjectOfEntries(hashParams.entries());

  return {
    ...hashParamsObject,
    ...searchParamsObject,
  };
};

function getObjectOfEntries(iterator) {
  const result = {};
  for (const [key, value] of iterator) {
    result[key] = value;
  }

  return result;
}

export const processOpenWithPopup = (url) => {
  // const windowFeatures = 'toolbar=no, titlebar=no, menubar=no, width=500, height=700, top=100, left=100';
  const popup = window.open(url, '_blank');
  popup?.focus();

  return popup;
  // window.location.href = url;
  // window.open(
  //   `https://accounts.google.com/o/oauth2/auth?client_id=YOUR_CLIENT_ID&redirect_uri=YOUR_REDIRECT_URL&response_type=code`,
  //   "_blank"
  // );
};

export const processPopupMessage = (popup) => {
  return new Promise((resolve, reject) => {
    let closeCheckIntervalId;

    if (popup) {
      closeCheckIntervalId = setInterval(() => {
        if (popup.closed) {
          clearInterval(closeCheckIntervalId);

          reject({ message: 'Error occured while verifying credentials!' });
        }
      }, 1000);
    }

    const messageHandler = async (event) => {
      if (event.data.source !== 'automatisch') {
        return;
      }

      const data = parseUrlSearchParams(event);
      window.removeEventListener('message', messageHandler);

      if (closeCheckIntervalId) {
        clearInterval(closeCheckIntervalId);
      }

      resolve(data);
    };

    window.addEventListener('message', messageHandler, false);
  });
};
